export const capitalize = (str: string): string => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const errorMessageHandler = (err: any, defaultMsg = "Something went wrong!!!"): string => {
    const errorMessage = err?.data?.errors?.[0] || err?.data?.message || err.errors?.[0] || err?.message || defaultMsg;
    return errorMessage;
}

export const normalizeEmail = (email: string): string => email.trim().toLowerCase();

export const getInvalidEmails = (emails: string[]): string[] => {
    const EMAIL_REGEX = /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
    return emails.filter(email => !EMAIL_REGEX.test(normalizeEmail(email)));
}

export const joinItems = (items?: string | string[], joiner = ', '): string => {
    if (!items || (Array.isArray(items) && items.length === 0))  return '-';
    return Array.isArray(items) ? items.join(joiner) : items;
};